export default function Voorwaarden() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-[#0A66C2]" style={{ fontFamily: '"Pacifico", serif' }}>
                StarSales
              </a>
            </div>
            <div className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Home</a>
              <a href="/over-ons" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Over ons</a>
              <a href="/contact" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Contact</a>
            </div>
            <div className="flex items-center space-x-4">
              <a href="tel:097010224137" className="text-[#0A66C2] hover:text-[#F57C00] font-medium transition-colors">
                0970 102 241 37
              </a>
              <button className="bg-[#F57C00] text-white px-4 py-2 rounded-full font-medium hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer">
                Gratis check
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#0A66C2] to-[#1976D2] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-3xl md:text-5xl font-bold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Algemene <span className="text-[#F57C00]">Voorwaarden</span>
            </h1>
            <p className="text-lg md:text-xl text-blue-100" style={{ fontFamily: '"Inter", sans-serif' }}>
              StarSales B.V. - Transparante voorwaarden voor onze dienstverlening
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Company Info */}
          <div className="bg-gray-50 rounded-2xl p-8 mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Bedrijfsgegevens
            </h2>
            <div className="space-y-2 text-gray-700" style={{ fontFamily: '"Inter", sans-serif' }}>
              <p className="font-semibold">StarSales B.V.</p>
              <p>Mgr. Cornelis Veermanlaan 63</p>
              <p>1131 KE Volendam – Nederland</p>
              <p>KvK: 97377562</p>
              <p>Telefoon: 0970 102 241 37</p>
            </div>
          </div>

          {/* Terms Content */}
          <div className="prose prose-lg max-w-none">
            {/* Article 1 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 1 – Definities
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>In deze voorwaarden wordt verstaan onder:</p>
                <p><strong>Opdrachtgever:</strong> de partij die een overeenkomst sluit met StarSales B.V.</p>
                <p><strong>Dienstverlener:</strong> StarSales B.V.</p>
                <p><strong>Overeenkomst:</strong> de afspraken tussen opdrachtgever en dienstverlener betreffende de levering van diensten.</p>
                <p><strong>Diensten:</strong> het ontwikkelen van websites, online marketing (o.a. Google Ads, social media advertenties), SEO/SEA, hosting en aanverwante activiteiten.</p>
              </div>
            </div>

            {/* Article 2 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 2 – Toepasselijkheid
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>Deze voorwaarden zijn van toepassing op alle offertes, overeenkomsten en leveringen van diensten door StarSales B.V.</p>
                <p>Afwijkingen zijn alleen geldig indien schriftelijk overeengekomen.</p>
              </div>
            </div>

            {/* Article 3 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 3 – Offertes en prijzen
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>Offertes zijn vrijblijvend en 30 dagen geldig, tenzij anders vermeld.</p>
                <p>Alle prijzen zijn exclusief btw en andere heffingen, tenzij uitdrukkelijk anders vermeld.</p>
                <p>StarSales B.V. behoudt zich het recht voor prijzen te wijzigen bij verlenging van diensten of gewijzigde omstandigheden.</p>
              </div>
            </div>

            {/* Article 4 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 4 – Uitvoering van de overeenkomst
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>StarSales B.V. zal de overeenkomst naar beste inzicht en vermogen uitvoeren.</p>
                <p>Voor een succesvolle uitvoering dient de opdrachtgever tijdig juiste informatie en materialen aan te leveren.</p>
                <p>Termijnen voor oplevering zijn indicatief en geen fatale termijnen, tenzij schriftelijk anders is overeengekomen.</p>
              </div>
            </div>

            {/* Article 5 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 5 – Betaling
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>Betaling dient te geschieden binnen 14 dagen na factuurdatum, tenzij anders overeengekomen.</p>
                <p>Bij te late betaling is de opdrachtgever zonder ingebrekestelling in verzuim en wordt wettelijke rente in rekening gebracht.</p>
                <p>Alle kosten voortvloeiend uit incasso komen voor rekening van de opdrachtgever.</p>
              </div>
            </div>

            {/* Article 6 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 6 – Intellectueel eigendom
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>Alle rechten op door StarSales B.V. geleverde ontwerpen, codes, teksten en andere creaties blijven bij StarSales B.V., tenzij anders overeengekomen.</p>
                <p>De opdrachtgever verkrijgt uitsluitend een gebruiksrecht voor de overeengekomen doeleinden.</p>
              </div>
            </div>

            {/* Article 7 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 7 – Hosting en onderhoud
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>Bij hosting en onderhoud zal StarSales B.V. zich inspannen voor een goede beschikbaarheid, maar geeft geen absolute garanties.</p>
                <p>StarSales B.V. is niet aansprakelijk voor storingen, uitval of gegevensverlies buiten haar invloed.</p>
              </div>
            </div>

            {/* Article 8 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 8 – Aansprakelijkheid
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>StarSales B.V. is slechts aansprakelijk voor directe schade die aantoonbaar het gevolg is van opzet of grove nalatigheid.</p>
                <p>Aansprakelijkheid voor indirecte schade, zoals gederfde winst of gemiste omzet, is uitgesloten.</p>
                <p>De maximale aansprakelijkheid is beperkt tot het bedrag dat voor de betreffende dienst in rekening is gebracht.</p>
              </div>
            </div>

            {/* Article 9 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 9 – Duur en beëindiging
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>Contracten voor terugkerende diensten (zoals hosting of campagnes) worden aangegaan voor de overeengekomen periode en stilzwijgend verlengd, tenzij minimaal 1 maand voor afloop schriftelijk wordt opgezegd.</p>
                <p>StarSales B.V. kan de overeenkomst per direct beëindigen bij wanbetaling of bij misbruik van diensten.</p>
              </div>
            </div>

            {/* Article 10 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 10 – Overmacht
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>StarSales B.V. is niet aansprakelijk bij niet-nakoming door overmacht, zoals storingen in internet, stroomuitval, overheidsmaatregelen, ziekte of stakingen.</p>
              </div>
            </div>

            {/* Article 11 */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Artikel 11 – Toepasselijk recht
              </h2>
              <div className="text-gray-700 space-y-4" style={{ fontFamily: '"Inter", sans-serif' }}>
                <p>Op alle overeenkomsten is uitsluitend Nederlands recht van toepassing.</p>
                <p>Geschillen worden voorgelegd aan de bevoegde rechter in het arrondissement van vestiging van StarSales B.V.</p>
              </div>
            </div>
          </div>

          {/* Contact CTA */}
          <div className="bg-gradient-to-r from-[#0A66C2] to-[#1976D2] rounded-2xl p-8 text-white text-center mt-16">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
              Vragen over onze voorwaarden?
            </h3>
            <p className="text-blue-100 mb-6" style={{ fontFamily: '"Inter", sans-serif' }}>
              Neem gerust contact met ons op voor verduidelijking
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="/contact" className="bg-[#F57C00] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer inline-block">
                Neem contact op
              </a>
              <a href="tel:097010224137" className="border-2 border-white text-white px-6 py-3 rounded-full font-semibold hover:bg-white hover:text-[#0A66C2] transition-colors whitespace-nowrap cursor-pointer inline-block">
                Bel ons: 0970 102 241 37
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center mb-6">
                <span className="text-3xl font-bold text-[#0A66C2]" style={{ fontFamily: '"Pacifico", serif' }}>
                  StarSales
                </span>
              </div>
              <p className="text-gray-300 mb-6 max-w-md" style={{ fontFamily: '"Inter", sans-serif' }}>
                StarSales B.V. helpt ZZP en kleine bedrijven groeien met websites, Google Ads, social media advertenties en meer.
              </p>
              <div className="space-y-2 text-gray-300">
                <p>Mgr. Cornelis Veermanlaan 63</p>
                <p>1131 KE Volendam</p>
                <p>KvK: 97377562</p>
                <p>Tel: 0970 102 241 37</p>
                <p>E-mail: info@starsales.nl</p>
              </div>
            </div>
            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Diensten
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Websites</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Google Ads</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Social Media Ads</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">SEO</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Hosting</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Links
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li><a href="/privacy" className="hover:text-[#F57C00] transition-colors">Privacy</a></li>
                <li><a href="/cookies" className="hover:text-[#F57C00] transition-colors">Cookies</a></li>
                <li><a href="/voorwaarden" className="hover:text-[#F57C00] transition-colors">Voorwaarden</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 StarSales B.V. Alle rechten voorbehouden.
            </p>
            <div className="flex space-x-4 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}